<template>
  <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.1" width="72" height="48"
    viewBox="0 0 72 48" preserveAspectRatio="none" xml:space="preserve" id="valve" style="z-index: 2">
    <title>Задвижка</title>
    <defs>
      <!--#C0DCC0-->
      <!--<linearGradient
        id="KeyGradient"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="24"
        x2="0"
        y2="48"
      >
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="0" />
        <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="1" />
      </linearGradient>
      <linearGradient
        id="KeyGradient2"
        gradientUnits="userSpaceOnUse"
        x1="24"
        y1="0"
        x2="48"
        y2="0"
      >
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="0.05" />
        <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="0.95" />
      </linearGradient>-->
      <linearGradient id="KeyGradient" gradientUnits="userSpaceOnUse" x1="0" y1="24" x2="0" y2="48">
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="0" />
        <stop style="stop-opacity: 1; stop-color: #dedede" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="1" />
      </linearGradient>
      <linearGradient id="KeyGradient2" gradientUnits="userSpaceOnUse" x1="24" y1="0" x2="48" y2="0">
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="0.05" />
        <stop style="stop-opacity: 1; stop-color: #dedede" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #918f90" offset="0.95" />
      </linearGradient>
      <linearGradient id="OilGradient" gradientUnits="userSpaceOnUse" x1="0" y1="24" x2="0" y2="48">
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="0" />
        <stop style="stop-opacity: 1; stop-color: grey" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="1" />
      </linearGradient>
      <linearGradient id="OilGradient2" gradientUnits="userSpaceOnUse" x1="24" y1="0" x2="48" y2="0">
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="0" />
        <stop style="stop-opacity: 1; stop-color: grey" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="1" />
      </linearGradient>
      <linearGradient id="YelGradient" gradientUnits="userSpaceOnUse" x1="0" y1="24" x2="0" y2="48">
        <stop style="stop-opacity: 1; stop-color: grey" offset="0" />
        <stop style="stop-opacity: 1; stop-color: #FCFA98" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: grey" offset="1" />
      </linearGradient>
      <linearGradient id="YelGradient2" gradientUnits="userSpaceOnUse" x1="24" y1="0" x2="48" y2="0">
        <stop style="stop-opacity: 1; stop-color: grey" offset="0" />
        <stop style="stop-opacity: 1; stop-color: #FCFA98" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: grey" offset="1" />
      </linearGradient> <!--#FCFA98-->
      <linearGradient id="CrashGradient" gradientUnits="userSpaceOnUse" x1="0" y1="24" x2="0" y2="48">
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="0" />
        <stop style="stop-opacity: 1; stop-color: red" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="1" />
      </linearGradient>
      <linearGradient id="CrashGradient2" gradientUnits="userSpaceOnUse" x1="24" y1="0" x2="48" y2="0">
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="0" />
        <stop style="stop-opacity: 1; stop-color: red" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: #4d4d4d" offset="1" />
      </linearGradient>
      <filter style="color-interpolation-filters: sRGB" id="f-#4D4D4D">
        <feColorMatrix type="luminanceToAlpha" result="result2" id="feColorMatrix5373" />
        <feComposite in2="SourceGraphic" operator="arithmetic" in="result2" k3="2" result="result4"
          id="feComposite5375" />
        <feBlend in="result4" mode="multiply" result="result3" in2="result2" id="feBlend5377" />
        <feComposite in2="SourceGraphic" operator="in" in="result3" id="feComposite5379" />
      </filter>
      <filter style="color-interpolation-filters: sRGB" id="f-green">
        <feComposite in2="SourceGraphic" operator="arithmetic" k1="0" k2="1" result="composite1" id="feComposite5527" />
        <feColorMatrix in="composite1" values="1" type="saturate" result="colormatrix1" id="feColorMatrix5529" />
        <feFlood flood-opacity="0.768627" flood-color="rgb(35,234,39)" result="flood1" id="feFlood5531" />
        <feBlend in="flood1" in2="colormatrix1" mode="multiply" result="blend1" id="feBlend5533" />
        <feBlend in2="blend1" mode="screen" result="blend2" id="feBlend5535" />
        <feColorMatrix in="blend2" values="1" type="saturate" result="colormatrix2" id="feColorMatrix5537" />
        <feComposite in="colormatrix2" in2="SourceGraphic" operator="in" k2="1" result="composite2"
          id="feComposite5539" />
      </filter>
      <filter style="color-interpolation-filters: sRGB" id="f-red">
        <feComposite in2="SourceGraphic" operator="arithmetic" k1="0" k2="1" result="composite1" id="feComposite5543" />
        <feColorMatrix in="composite1" values="1" type="saturate" result="colormatrix1" id="feColorMatrix5545" />
        <feFlood flood-opacity="0.768627" flood-color="rgb(255,0,0)" result="flood1" id="feFlood5547" />
        <feBlend in="flood1" in2="colormatrix1" mode="multiply" result="blend1" id="feBlend5549" />
        <feBlend in2="blend1" mode="screen" result="blend2" id="feBlend5551" />
        <feColorMatrix in="blend2" values="1" type="saturate" result="colormatrix2" id="feColorMatrix5553" />
        <feComposite in="colormatrix2" in2="SourceGraphic" operator="in" k2="1" result="composite2"
          id="feComposite5555" />
      </filter>
      <filter style="color-interpolation-filters: sRGB" id="f-yellow">
        <feComposite in2="SourceGraphic" operator="arithmetic" k1="0" k2="1" result="composite1" id="feComposite5591" />
        <feColorMatrix in="composite1" values="1" type="saturate" result="colormatrix1" id="feColorMatrix5593" />
        <feFlood flood-opacity="1" flood-color="rgb(255,255,66)" result="flood1" id="feFlood5595" />
        <feBlend in="flood1" in2="colormatrix1" mode="multiply" result="blend1" id="feBlend5597" />
        <feBlend in2="blend1" mode="screen" result="blend2" id="feBlend5599" />
        <feColorMatrix in="blend2" values="1" type="saturate" result="colormatrix2" id="feColorMatrix5601" />
        <feComposite in="colormatrix2" in2="SourceGraphic" operator="in" k2="1" result="composite2"
          id="feComposite5603" />
      </filter>
      <rect id="main_valve_item_0" y="20" width="72" height="24" />
      <path id="path_valve" d="M 24,0 v 24 Q 34 34 48 24 V 0 z" />
      <rect id="main_valve_item_1" x="18" y="5" width="36" height="8" stroke="#918f90" />
      <rect id="main_valve_item_2" y="16" width="8" height="32" stroke="#918f90" />
      <rect id="main_valve_item_3" x="64" y="16" width="8" height="32" stroke="#918f90" />
      <rect id="main_valve_item_4" x="44" y="1" width="28" height="3" />
    </defs>
    <!-- style="filter:url(#f-yellow)" образец работы с цветом через фильтры -->
    <g :visibility="fState[0]">
      <use href="#main_valve_item_0" fill="url(#KeyGradient)" />
      <use href="#path_valve" fill="url(#KeyGradient2)" />
      <use href="#main_valve_item_1" fill="url(#KeyGradient2)" />
      <use href="#main_valve_item_2" fill="url(#KeyGradient)" />
      <use href="#main_valve_item_3" fill="url(#KeyGradient)" />
      <use href="#main_valve_item_4" fill="url(#KeyGradient2)" />
    </g>
    <g :visibility="fState[4]">
      <use href="#main_valve_item_0" fill="url(#YelGradient)" />
      <use href="#path_valve" fill="url(#YelGradient2)" />
      <use href="#main_valve_item_1" fill="url(#YelGradient2)" />
      <use href="#main_valve_item_2" fill="url(#YelGradient)" />
      <use href="#main_valve_item_3" fill="url(#YelGradient)" />
      <use href="#main_valve_item_4" fill="url(#YelGradient2)" />
    </g>
    <g :visibility="fState[5]">
      <use href="#main_valve_item_0" fill="url(#OilGradient)" />
      <use href="#path_valve" fill="url(#OilGradient2)" />
      <use href="#main_valve_item_1" fill="url(#OilGradient2)" />
      <use href="#main_valve_item_2" fill="url(#OilGradient)" />
      <use href="#main_valve_item_3" fill="url(#OilGradient)" />
      <use href="#main_valve_item_4" fill="url(#OilGradien2)" />
    </g>
    <!-- <g class="state-2"  >   
		<use href="#main_valve_item_0" fill="url(#KeyGradient)" />
		<use href="#path0" fill="url(#KeyGradient2)" />
		<use href="#main_valve_item_1" fill="url(#KeyGradient2)" />
		<use href="#main_valve_item_2" fill="url(#KeyGradient)" />
		<use href="#main_valve_item_3" fill="url(#KeyGradient)" />
		<use href="#main_valve_item_4" fill="url(#KeyGradient2)" />
		</g> -->
    <g :visibility="fState[3]">
      <use href="#main_valve_item_0" fill="url(#CrashGradient)" />
      <use href="#path_valve" fill="url(#CrashGradient2)" />
      <use href="#main_valve_item_1" fill="url(#CrashGradient2)" />
      <use href="#main_valve_item_2" fill="url(#CrashGradient)" />
      <use href="#main_valve_item_3" fill="url(#CrashGradient)" />
      <use href="#main_valve_item_4" fill="url(#CrashGradient2)" />
    </g>
    <g :visibility="fState[2]">
      <use href="#main_valve_item_0" fill="url(#CrashGradient)" />
      <use href="#path_valve" fill="url(#CrashGradient2)" />
      <use href="#main_valve_item_1" fill="url(#CrashGradient2)" />
      <use href="#main_valve_item_2" fill="url(#CrashGradient)" />
      <use href="#main_valve_item_3" fill="url(#CrashGradient)" />
      <use href="#main_valve_item_4" fill="url(#CrashGradient2)" />
    </g>
    <g :visibility="fState[1]">
      <use href="#main_valve_item_0" fill="url(#YelGradient)" />
      <use href="#path_valve" fill="url(#YelGradient2)" />
      <use href="#main_valve_item_1" fill="url(#YelGradient2)" />
      <use href="#main_valve_item_2" fill="url(#YelGradient)" />
      <use href="#main_valve_item_3" fill="url(#YelGradient)" />
      <use href="#main_valve_item_4" fill="url(#YelGradient2)" />
    </g>
    <g :visibility="fState[10]">
      <use href="#main_valve_item_0" fill="url(#YelGradient)" />
      <use href="#path_valve" fill="url(#YelGradient2)" />
      <use href="#main_valve_item_1" fill="url(#YelGradient2)" />
      <use href="#main_valve_item_2" fill="url(#YelGradient)" />
      <use href="#main_valve_item_3" fill="url(#YelGradient)" />
      <use href="#main_valve_item_4" fill="url(#YelGradient2)" />
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "valve",
  mixins: [MixinStates],
  computed: {
    fState: function () {
      let states = ["hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden"];
      if (!this.PropertyURI) {
        states[0] = "visible";
        return states;
      }
      if (this.binary) {
        if (this.value) {
          states[5] = "visible"
        }
        else {
          states[1] = "visible"
        }
      } else
        this.stateSwitch(states, this.value)
      return states;
    }
  },
};
</script>
